import { NgModule } from '@angular/core';
import { HisAuthSharedModule } from './auth/his-auth-shared.module';
import { HisCommunicationlogSharedModule } from './communicationlog/communicationlog-shared.module';
import { HisCoreSharedModule } from './core/his-core-shared.module';
import { HisDisplaySharedModule } from './display/his-display-shared.module';
import { HisDynamicFormSharedModule } from './dynamicform/his-dynamicform-shared.module';
import { HisGenericsearchSharedModule } from './genericsearch/his-genericsearch-shared.module';
import { HisInputPersonalAgreementSharedModule } from './input/component/inputPersonalAgreement/his-input-personal-agreement-shared.module';
import { HisInputSharedModule } from './input/his-input-shared.module';
import { HisJobsSharedModule } from './jobs/his-jobs-shared.module';
import { HisNavigationSharedModule } from './navigation/his-navigation-shared.module';
import { HisProblemCaseSharedModule } from './problemcase/his-problem-case-shared.module';
import { HisStructureSharedModule } from './structure/his-structure-shared.module';
import { HisTableSharedModule } from './table/his-table-shared.module';
import { HisTranslationSharedModule } from './translation/his-translation-shared.module';
import { HisTreeSharedModule } from './tree/his-tree-shared.module';
import { HisFileUploadSharedModule } from './upload/his-file-upload-shared.module';

/**
 * SharedModule with the components, directives, and pipes to import in child
 * modules of HIS Angular applications. Import HisCoreModule in the root module.
 */
@NgModule( {
    imports: [
        HisAuthSharedModule,
        HisCoreSharedModule,
        HisDisplaySharedModule,
        HisDynamicFormSharedModule,
        HisGenericsearchSharedModule,
        HisInputSharedModule,
        HisJobsSharedModule,
        HisStructureSharedModule,
        HisTableSharedModule,
        HisTreeSharedModule,
        HisTranslationSharedModule,
        HisFileUploadSharedModule,
        HisCommunicationlogSharedModule,
        HisNavigationSharedModule,
        HisProblemCaseSharedModule,
        HisInputPersonalAgreementSharedModule,
    ],
    exports: [
        HisAuthSharedModule,
        HisCoreSharedModule,
        HisDisplaySharedModule,
        HisDynamicFormSharedModule,
        HisGenericsearchSharedModule,
        HisInputSharedModule,
        HisJobsSharedModule,
        HisStructureSharedModule,
        HisTableSharedModule,
        HisTreeSharedModule,
        HisTranslationSharedModule,
        HisFileUploadSharedModule,
        HisCommunicationlogSharedModule,
        HisNavigationSharedModule,
        HisProblemCaseSharedModule,
        HisInputPersonalAgreementSharedModule,
    ]
    // NO PROVIDERS! Providers need to go into HisCoreModule
} )
export class HisSharedModule { }
